import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'input-switch',
  shadow: false,
})
export class InputSwitch {
  @Prop() name: string;
  @Prop() label: string;
  @Prop() value: string;
  @Prop() required: boolean;
  @Prop() tooltip: string;
  @Prop() disabled: boolean;
  @Prop() checked: boolean;
  @Prop() dataTab: string;

  render() {
    return (
      <div class="form-check form-switch">
        <label-tooltip label={this.label} tooltip={this.tooltip}></label-tooltip>
        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" data-tab={this.dataTab} name={this.name} disabled={this.disabled} checked={this.checked} />
      </div>
    );
  }
}
